export default __webpack_public_path__ + "static/media/logo_odrrr.1d135cb8.svg";